<div role="navigation" [attr.aria-label]="appTilesLandmarkAriaLabel" class="app-tiles-list-component" @fadeOut>
    <div *ngIf="showProvisioningAlert"
         class="tiles-section__alert--fluent ms-fcl-nd"
         [ngStyle]="{ 'color': fullBleedFontColor }">
        <ohp-alert-message [message]="provisioningAlertText"></ohp-alert-message>
    </div>
    <div class="tiles-section__container" [ngClass]="{ 'mobile-tiles-section__container': isMobile }">
        <div [ngClass]="{'large-tiles-container': !!promotedAppTile, 'mobile-tiles--outer mobile-tiles--virtual-outer': isMobile }">
            <div class="fluent-tiles"
                 [ngClass]="{ 'mobile-tiles--inner': isMobile }">
                <ng-container *ngIf="workloads">
                    <ng-container *ngIf="!isMobile">
                        <div class="tiles__container" *ngIf="createMenuEnabled">
                            <ohp-create-menu-placeholder-tile *ngIf="showCreatePlaceholder" [forceWhiteBackground]="fullBleedTheming"></ohp-create-menu-placeholder-tile>
                            <ng-container ohpLazyView
                                          (ohpLazyViewComponentLoaded)="removePlaceholder()"
                                          ngModulePath="create-menu#CreateMenuModule"
                                          [inputs]="{
                                                tileView: true,
                                                componentArea: componentArea,
                                                forceWhiteBackground: fullBleedTheming,
                                                scaleTile: scaleTile
                                          }">
                            </ng-container>
                        </div>
                        <div class="tiles__container"
                             *ngFor="let workload of workloads | slice:0:getDisplayedAppTilesCount(); let i = index; trackBy: trackByWorkloadId">
                            <ohp-app-tile *ngIf="!isConsumer" [workload]="workload" [inExpandedView]="i >= reducedTilesCount" [promotedAppTile]="i === promotedIndex" [forceWhiteBackground]="fullBleedTheming" [pinnedApp]="pinnedAppsEnabled" (unpinWorkload)="onUnpinWorkload($event)"></ohp-app-tile>
                            <ohp-app-tile *ngIf="isConsumer" [workload]="workload" [inExpandedView]="false" [promotedAppTile]="false"></ohp-app-tile>
                        </div>
                        <div *ngIf="showAppGalleryLink"
                             class="tiles__container">
                             <div class="workload-item"
                                  [ngClass]="{'animated-tile': scaleTile}">
                                <a id="explore-your-apps"
                                    class="workload-item__link workload-item--provisioned workload-item--fluent--provisioned workload-item--fluent__link ms-fcl-tda ms-bgc-w-h ms-bgc-w-a ms-bgc-w-f"
                                    [ngClass]="{'ms-bgc-w': fullBleedTheming}"
                                    [attr.aria-label]="exploreYourAppsAriaLabel"
                                    [attr.data-area]="componentArea"
                                    data-nav=1
                                    (click)="navigateToAppsPage()"
                                    href="javascript:void(0);"
                                    #appGalleryLink>
                                    <span class="workload-item__icon--fluent non-workload-item__icon ms-fcl-tda">
                                        <ohp-icon-font iconFontName="ArrowRight" size="32" cssClass="link-arrow--flip"></ohp-icon-font>
                                    </span>
                                    <div class="workload-item__name--fluent">
                                        <div class="workload-item__text--fluent non-workload-link__text ms-fcl-tda">{{ appGalleryTileText }}</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </ng-container>
                     <ng-container *ngIf="isMobile">
                        <cdk-virtual-scroll-viewport itemSize="100" maxBufferPx="100" minBufferPx="50" orientation="horizontal" class="virtual-scroll-tiles">
                            <div class="tiles__content tiles__content--touch" *cdkVirtualFor="let workload of workloads | slice:0:getDisplayedAppTilesCount(); let i = index; trackBy: trackByWorkloadId">
                                <ohp-app-tile *ngIf="!isConsumer" [workload]="workload" [inExpandedView]="i >= reducedTilesCount" [promotedAppTile]="i === promotedIndex" [forceWhiteBackground]="fullBleedTheming"></ohp-app-tile>
                                <ohp-app-tile *ngIf="isConsumer" [workload]="workload" [inExpandedView]="false" [promotedAppTile]="false"></ohp-app-tile>
                            </div>
                        </cdk-virtual-scroll-viewport>
                    </ng-container>
                </ng-container>
            </div>
            <div *ngIf="!!promotedAppTile && !isMobile">
                <ohp-app-tile [workload]="promotedAppTile" [inExpandedView]="false" [promotedAppTile]="true"></ohp-app-tile>
            </div>
        </div>
        <div *ngIf="showAppGalleryLink && !bottomTrayEnabled && isMobile"
             class="explore-apps--fluent"
             [ngClass]="{'explore-apps--backplate': fullBleedBackplateEnabled}">
            <a id="explore-your-apps"
               class="explore-apps__text--fluent ms-fcl-tda ms-fcl-tda-h ms-fcl-tdr-f ms-fcl-tdr-a"
               [ngClass]="{'explore-apps__text--backplate': fullBleedBackplateEnabled}"
               [ngStyle]="fullBleedBackplateStyle"
               [attr.aria-label]="exploreYourAppsAriaLabel"
               [attr.data-area]="componentArea"
               [attr.data-nav]="true"
               (click)="navigateToAppsPage()"
               href="javascript:void(0);"
               [ohpPreload]="appGalleryRoute"
               #appGalleryLink>
                <div class="centered-flex-container">
                    <span>{{ exploreYourAppsText }}</span>
                    <ohp-icon-font iconFontName="ArrowRight" size="14" cssClass="link-arrow"></ohp-icon-font>
                </div>
            </a>
        </div>
    </div>
</div>
